"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageOnLayer = getImageOnLayer;
exports.rotateAllLayers = rotateAllLayers;
exports.rotateElementsOnLayer = rotateElementsOnLayer;
exports.rotateLayer = rotateLayer;
exports.rotateTypeOnLayer = rotateTypeOnLayer;
exports.scaleElementsOnLayer = scaleElementsOnLayer;
var _Rotate = require("../transformations/Rotate");
var _Scale = require("../transformations/Scale");
var _operations = require("../transformations/_operations");
function rotateTypeOnLayer(layer, type, deg) {
  if (typeof type === "string") {
    layer.find(type).forEach(function (el) {
      var pivotPoint = {
        x: 0,
        y: 0
      };
      (0, _Rotate.rotateElement)(el, deg, pivotPoint);
    });
  } else {
    console.warn("invalid type = ".concat(type));
  }
}
function rotateElementsOnLayer(layer, deg, origin) {
  // find layer center with respect to top-left origin
  layer.children.forEach(function (el) {
    (0, _Rotate.rotateElement)(el, deg, origin);
  });
}
function scaleElementsOnLayer(layer, scale, origin) {
  var _origin;
  var boundingBox = layer.getClientRect();
  var width = 640 || boundingBox.width;
  var height = 480 || boundingBox.height;
  origin = (_origin = origin) !== null && _origin !== void 0 ? _origin : (0, _operations.getRelativeCenter)({
    width: width,
    height: height
  });
  layer.children.forEach(function (el) {
    (0, _Scale.scaleElement)(el, scale, origin);
  });
}
function rotateLayer(layer, deg, scale, origin) {
  var _origin2;
  origin = (_origin2 = origin) !== null && _origin2 !== void 0 ? _origin2 : {
    x: 640 / 2,
    y: 480 / 2
  };
  if (!scale) {
    var stage = layer.getParent();

    // get stage dimensions
    var width = stage.width();
    var height = stage.height();
    scale = {
      x: height / width,
      y: height / width
    };
  }

  // rotate layer
  rotateElementsOnLayer(layer, deg, origin);

  // scale to avoid clipping
  if (deg % 180 !== 0) {
    scaleElementsOnLayer(layer, scale);
  } else {
    scaleElementsOnLayer(layer, {
      x: 1,
      y: 1
    });
  }
}
function rotateAllLayers(stage, deg) {
  // check stage and layers are accessible
  if (!stage) return;

  // rotate each layer in the stage
  stage.children.forEach(function (layer) {
    rotateLayer(layer, deg);
  });
}
function getImageOnLayer(layer, id) {
  var type = "Image";
  // Use '#' to select elements by ID and ',' to combine multiple selectors
  var foundImage = layer.find("#".concat(id, ", ").concat(type));
  return foundImage[0] || null;
}